import { ShopifyStore } from 'lib/commerce/shopify/shopifyHelper';
import {
  RareColors,
  MiscRingCheckoutTypes,
  RingVariantType,
} from './constants';
import { deepExpandStoreAliases } from '../../storeAliasHelper';
import { RingSizes } from '../../ring/productMap';

// Main product map for rare rings - simplified structure without RingType layer since no engraving option
export const productMap_rare_PROD: Partial<
  Record<RareColors, Partial<Record<RingSizes, RingVariantType>>>
> = {
  [RareColors.DESERT_SNOW]: {
    [RingSizes.FIVE]: {
      SKU: 'RARE_DS_5',
      variantId: {
        [ShopifyStore.IN]: 'gid://shopify/ProductVariant/42764585435206',
        [ShopifyStore.AE]: 'gid://shopify/ProductVariant/62134117532019',
        [ShopifyStore.ROW]: 'gid://shopify/ProductVariant/42669740687420',
        [ShopifyStore.US]: 'gid://shopify/ProductVariant/41731305046112',
        [ShopifyStore.EU]: 'gid://shopify/ProductVariant/55416353292662',
        [ShopifyStore.GB]: 'gid://shopify/ProductVariant/55416353292662',
      },
      checkoutUrl: {
        [ShopifyStore.IN]:
          'https://ultrahumanstore.myshopify.com/cart/42764585435206:1?channel=buy_button',
        [ShopifyStore.AE]:
          'https://ultrahuman-mena.myshopify.com/cart/62134117532019:1?channel=buy_button',
        [ShopifyStore.ROW]:
          'https://ultrahuman-us.myshopify.com/cart/42669740687420:1?channel=buy_button',
        [ShopifyStore.US]:
          'https://stelcore-x-ultrahuman.myshopify.com/cart/41731305046112:1?channel=buy_button',
        [ShopifyStore.EU]:
          'https://ultrahuman-eu-uk.myshopify.com/cart/55416353292662:1?channel=buy_button',
        [ShopifyStore.GB]:
          'https://ultrahuman-eu-uk.myshopify.com/cart/55416353292662:1?channel=buy_button',
      },
      misc: {
        [MiscRingCheckoutTypes.BETTER_HELP_CHECKOUT]: '',
      },
    },
    [RingSizes.SIX]: {
      SKU: 'RARE_DS_6',
      variantId: {
        [ShopifyStore.IN]: 'gid://shopify/ProductVariant/42764585467974',
        [ShopifyStore.AE]: 'gid://shopify/ProductVariant/62134117564787',
        [ShopifyStore.ROW]: 'gid://shopify/ProductVariant/42669740720188',
        [ShopifyStore.US]: 'gid://shopify/ProductVariant/41731305078880',
        [ShopifyStore.EU]: 'gid://shopify/ProductVariant/55416353325430',
        [ShopifyStore.GB]: 'gid://shopify/ProductVariant/55416353325430',
      },
      checkoutUrl: {
        [ShopifyStore.IN]:
          'https://ultrahumanstore.myshopify.com/cart/42764585467974:1?channel=buy_button',
        [ShopifyStore.AE]:
          'https://ultrahuman-mena.myshopify.com/cart/62134117564787:1?channel=buy_button',
        [ShopifyStore.ROW]:
          'https://ultrahuman-us.myshopify.com/cart/42669740720188:1?channel=buy_button',
        [ShopifyStore.US]:
          'https://stelcore-x-ultrahuman.myshopify.com/cart/41731305078880:1?channel=buy_button',
        [ShopifyStore.EU]:
          'https://ultrahuman-eu-uk.myshopify.com/cart/55416353325430:1?channel=buy_button',
        [ShopifyStore.GB]:
          'https://ultrahuman-eu-uk.myshopify.com/cart/55416353325430:1?channel=buy_button',
      },
      misc: {
        [MiscRingCheckoutTypes.BETTER_HELP_CHECKOUT]: '',
      },
    },
    [RingSizes.SEVEN]: {
      SKU: 'RARE_DS_7',
      variantId: {
        [ShopifyStore.IN]: 'gid://shopify/ProductVariant/42764585500742',
        [ShopifyStore.AE]: 'gid://shopify/ProductVariant/62134117597555',
        [ShopifyStore.ROW]: 'gid://shopify/ProductVariant/42669740752956',
        [ShopifyStore.US]: 'gid://shopify/ProductVariant/41731305111648',
        [ShopifyStore.EU]: 'gid://shopify/ProductVariant/55416353358198',
        [ShopifyStore.GB]: 'gid://shopify/ProductVariant/55416353358198',
      },
      checkoutUrl: {
        [ShopifyStore.IN]:
          'https://ultrahumanstore.myshopify.com/cart/42764585500742:1?channel=buy_button',
        [ShopifyStore.AE]:
          'https://ultrahuman-mena.myshopify.com/cart/62134117597555:1?channel=buy_button',
        [ShopifyStore.ROW]:
          'https://ultrahuman-us.myshopify.com/cart/42669740752956:1?channel=buy_button',
        [ShopifyStore.US]:
          'https://stelcore-x-ultrahuman.myshopify.com/cart/41731305111648:1?channel=buy_button',
        [ShopifyStore.EU]:
          'https://ultrahuman-eu-uk.myshopify.com/cart/55416353358198:1?channel=buy_button',
        [ShopifyStore.GB]:
          'https://ultrahuman-eu-uk.myshopify.com/cart/55416353358198:1?channel=buy_button',
      },
      misc: {
        [MiscRingCheckoutTypes.BETTER_HELP_CHECKOUT]: '',
      },
    },
    [RingSizes.EIGHT]: {
      SKU: 'RARE_DS_8',
      variantId: {
        [ShopifyStore.IN]: 'gid://shopify/ProductVariant/42764585533510',
        [ShopifyStore.AE]: 'gid://shopify/ProductVariant/62134117630323',
        [ShopifyStore.ROW]: 'gid://shopify/ProductVariant/42669740785724',
        [ShopifyStore.US]: 'gid://shopify/ProductVariant/41731305144416',
        [ShopifyStore.EU]: 'gid://shopify/ProductVariant/55416353390966',
        [ShopifyStore.GB]: 'gid://shopify/ProductVariant/55416353390966',
      },
      checkoutUrl: {
        [ShopifyStore.IN]:
          'https://ultrahumanstore.myshopify.com/cart/42764585533510:1?channel=buy_button',
        [ShopifyStore.AE]:
          'https://ultrahuman-mena.myshopify.com/cart/62134117630323:1?channel=buy_button',
        [ShopifyStore.ROW]:
          'https://ultrahuman-us.myshopify.com/cart/42669740785724:1?channel=buy_button',
        [ShopifyStore.US]:
          'https://stelcore-x-ultrahuman.myshopify.com/cart/41731305144416:1?channel=buy_button',
        [ShopifyStore.EU]:
          'https://ultrahuman-eu-uk.myshopify.com/cart/55416353390966:1?channel=buy_button',
        [ShopifyStore.GB]:
          'https://ultrahuman-eu-uk.myshopify.com/cart/55416353390966:1?channel=buy_button',
      },
      misc: {
        [MiscRingCheckoutTypes.BETTER_HELP_CHECKOUT]: '',
      },
    },
    [RingSizes.NINE]: {
      SKU: 'RARE_DS_9',
      variantId: {
        [ShopifyStore.IN]: 'gid://shopify/ProductVariant/42764585566278',
        [ShopifyStore.AE]: 'gid://shopify/ProductVariant/62134117663091',
        [ShopifyStore.ROW]: 'gid://shopify/ProductVariant/42669740818492',
        [ShopifyStore.US]: 'gid://shopify/ProductVariant/41731305177184',
        [ShopifyStore.EU]: 'gid://shopify/ProductVariant/55416353423734',
        [ShopifyStore.GB]: 'gid://shopify/ProductVariant/55416353423734',
      },
      checkoutUrl: {
        [ShopifyStore.IN]:
          'https://ultrahumanstore.myshopify.com/cart/42764585566278:1?channel=buy_button',
        [ShopifyStore.AE]:
          'https://ultrahuman-mena.myshopify.com/cart/62134117663091:1?channel=buy_button',
        [ShopifyStore.ROW]:
          'https://ultrahuman-us.myshopify.com/cart/42669740818492:1?channel=buy_button',
        [ShopifyStore.US]:
          'https://stelcore-x-ultrahuman.myshopify.com/cart/41731305177184:1?channel=buy_button',
        [ShopifyStore.EU]:
          'https://ultrahuman-eu-uk.myshopify.com/cart/55416353423734:1?channel=buy_button',
        [ShopifyStore.GB]:
          'https://ultrahuman-eu-uk.myshopify.com/cart/55416353423734:1?channel=buy_button',
      },
      misc: {
        [MiscRingCheckoutTypes.BETTER_HELP_CHECKOUT]: '',
      },
    },
    [RingSizes.TEN]: {
      SKU: 'RARE_DS_10',
      variantId: {
        [ShopifyStore.IN]: 'gid://shopify/ProductVariant/42764585599046',
        [ShopifyStore.AE]: 'gid://shopify/ProductVariant/62134117695859',
        [ShopifyStore.ROW]: 'gid://shopify/ProductVariant/42669740851260',
        [ShopifyStore.US]: 'gid://shopify/ProductVariant/41731305209952',
        [ShopifyStore.EU]: 'gid://shopify/ProductVariant/55416353456502',
        [ShopifyStore.GB]: 'gid://shopify/ProductVariant/55416353456502',
      },
      checkoutUrl: {
        [ShopifyStore.IN]:
          'https://ultrahumanstore.myshopify.com/cart/42764585599046:1?channel=buy_button',
        [ShopifyStore.AE]:
          'https://ultrahuman-mena.myshopify.com/cart/62134117695859:1?channel=buy_button',
        [ShopifyStore.ROW]:
          'https://ultrahuman-us.myshopify.com/cart/42669740851260:1?channel=buy_button',
        [ShopifyStore.US]:
          'https://stelcore-x-ultrahuman.myshopify.com/cart/41731305209952:1?channel=buy_button',
        [ShopifyStore.EU]:
          'https://ultrahuman-eu-uk.myshopify.com/cart/55416353456502:1?channel=buy_button',
        [ShopifyStore.GB]:
          'https://ultrahuman-eu-uk.myshopify.com/cart/55416353456502:1?channel=buy_button',
      },
      misc: {
        [MiscRingCheckoutTypes.BETTER_HELP_CHECKOUT]: '',
      },
    },
    [RingSizes.ELEVEN]: {
      SKU: 'RARE_DS_11',
      variantId: {
        [ShopifyStore.IN]: 'gid://shopify/ProductVariant/42764585631814',
        [ShopifyStore.AE]: 'gid://shopify/ProductVariant/62134117728627',
        [ShopifyStore.ROW]: 'gid://shopify/ProductVariant/42669740884028',
        [ShopifyStore.US]: 'gid://shopify/ProductVariant/41731305242720',
        [ShopifyStore.EU]: 'gid://shopify/ProductVariant/55416353489270',
        [ShopifyStore.GB]: 'gid://shopify/ProductVariant/55416353489270',
      },
      checkoutUrl: {
        [ShopifyStore.IN]:
          'https://ultrahumanstore.myshopify.com/cart/42764585631814:1?channel=buy_button',
        [ShopifyStore.AE]:
          'https://ultrahuman-mena.myshopify.com/cart/62134117728627:1?channel=buy_button',
        [ShopifyStore.ROW]:
          'https://ultrahuman-us.myshopify.com/cart/42669740884028:1?channel=buy_button',
        [ShopifyStore.US]:
          'https://stelcore-x-ultrahuman.myshopify.com/cart/41731305242720:1?channel=buy_button',
        [ShopifyStore.EU]:
          'https://ultrahuman-eu-uk.myshopify.com/cart/55416353489270:1?channel=buy_button',
        [ShopifyStore.GB]:
          'https://ultrahuman-eu-uk.myshopify.com/cart/55416353489270:1?channel=buy_button',
      },
      misc: {
        [MiscRingCheckoutTypes.BETTER_HELP_CHECKOUT]: '',
      },
    },
    [RingSizes.TWELVE]: {
      SKU: 'RARE_DS_12',
      variantId: {
        [ShopifyStore.IN]: 'gid://shopify/ProductVariant/42764585631814',
        [ShopifyStore.AE]: 'gid://shopify/ProductVariant/62134117761395',
        [ShopifyStore.ROW]: 'gid://shopify/ProductVariant/42669740916796',
        [ShopifyStore.US]: 'gid://shopify/ProductVariant/41731305275488',
        [ShopifyStore.EU]: 'gid://shopify/ProductVariant/55416353522038',
        [ShopifyStore.GB]: 'gid://shopify/ProductVariant/55416353522038',
      },
      checkoutUrl: {
        [ShopifyStore.IN]:
          'https://ultrahumanstore.myshopify.com/cart/42764585631814:1?channel=buy_button',
        [ShopifyStore.AE]:
          'https://ultrahuman-mena.myshopify.com/cart/62134117761395:1?channel=buy_button',
        [ShopifyStore.ROW]:
          'https://ultrahuman-us.myshopify.com/cart/42669740916796:1?channel=buy_button',
        [ShopifyStore.US]:
          'https://stelcore-x-ultrahuman.myshopify.com/cart/41731305275488:1?channel=buy_button',
        [ShopifyStore.EU]:
          'https://ultrahuman-eu-uk.myshopify.com/cart/55416353522038:1?channel=buy_button',
        [ShopifyStore.GB]:
          'https://ultrahuman-eu-uk.myshopify.com/cart/55416353522038:1?channel=buy_button',
      },
      misc: {
        [MiscRingCheckoutTypes.BETTER_HELP_CHECKOUT]: '',
      },
    },
    [RingSizes.THIRTEEN]: {
      SKU: 'RARE_DS_13',
      variantId: {
        [ShopifyStore.IN]: 'gid://shopify/ProductVariant/42764585697350',
        [ShopifyStore.AE]: 'gid://shopify/ProductVariant/62134117794163',
        [ShopifyStore.ROW]: 'gid://shopify/ProductVariant/42669740949564',
        [ShopifyStore.US]: 'gid://shopify/ProductVariant/41731305308256',
        [ShopifyStore.EU]: 'gid://shopify/ProductVariant/55416353554806',
        [ShopifyStore.GB]: 'gid://shopify/ProductVariant/55416353554806',
      },
      checkoutUrl: {
        [ShopifyStore.IN]:
          'https://ultrahumanstore.myshopify.com/cart/42764585697350:1?channel=buy_button',
        [ShopifyStore.AE]:
          'https://ultrahuman-mena.myshopify.com/cart/62134117794163:1?channel=buy_button',
        [ShopifyStore.ROW]:
          'https://ultrahuman-us.myshopify.com/cart/42669740949564:1?channel=buy_button',
        [ShopifyStore.US]:
          'https://stelcore-x-ultrahuman.myshopify.com/cart/41731305308256:1?channel=buy_button',
        [ShopifyStore.EU]:
          'https://ultrahuman-eu-uk.myshopify.com/cart/55416353554806:1?channel=buy_button',
        [ShopifyStore.GB]:
          'https://ultrahuman-eu-uk.myshopify.com/cart/55416353554806:1?channel=buy_button',
      },
      misc: {
        [MiscRingCheckoutTypes.BETTER_HELP_CHECKOUT]: '',
      },
    },
    [RingSizes.FOURTEEN]: {
      SKU: 'RARE_DS_14',
      variantId: {
        [ShopifyStore.IN]: 'gid://shopify/ProductVariant/42764585730118',
        [ShopifyStore.AE]: 'gid://shopify/ProductVariant/62134117826931',
        [ShopifyStore.ROW]: 'gid://shopify/ProductVariant/42669740982332',
        [ShopifyStore.US]: 'gid://shopify/ProductVariant/41731305341024',
        [ShopifyStore.EU]: 'gid://shopify/ProductVariant/55416353587574',
        [ShopifyStore.GB]: 'gid://shopify/ProductVariant/55416353587574',
      },
      checkoutUrl: {
        [ShopifyStore.IN]:
          'https://ultrahumanstore.myshopify.com/cart/42764585730118:1?channel=buy_button',
        [ShopifyStore.AE]:
          'https://ultrahuman-mena.myshopify.com/cart/62134117826931:1?channel=buy_button',
        [ShopifyStore.ROW]:
          'https://ultrahuman-us.myshopify.com/cart/42669740982332:1?channel=buy_button',
        [ShopifyStore.US]:
          'https://stelcore-x-ultrahuman.myshopify.com/cart/41731305341024:1?channel=buy_button',
        [ShopifyStore.EU]:
          'https://ultrahuman-eu-uk.myshopify.com/cart/55416353587574:1?channel=buy_button',
        [ShopifyStore.GB]:
          'https://ultrahuman-eu-uk.myshopify.com/cart/55416353587574:1?channel=buy_button',
      },
      misc: {
        [MiscRingCheckoutTypes.BETTER_HELP_CHECKOUT]: '',
      },
    },
    [RingSizes.OPEN]: {
      SKU: 'LP00',
      variantId: {
        [ShopifyStore.IN]: 'gid://shopify/ProductVariant/42764585762886',
        [ShopifyStore.AE]: 'gid://shopify/ProductVariant/62134117859699',
        [ShopifyStore.ROW]: 'gid://shopify/ProductVariant/42669741015100',
        [ShopifyStore.US]: 'gid://shopify/ProductVariant/41731305373792',
        [ShopifyStore.EU]: 'gid://shopify/ProductVariant/55416353620342',
        [ShopifyStore.GB]: 'gid://shopify/ProductVariant/55416353620342',
      },
      checkoutUrl: {
        [ShopifyStore.IN]:
          'https://ultrahumanstore.myshopify.com/cart/42764585762886:1?channel=buy_button',
        [ShopifyStore.AE]:
          'https://ultrahuman-mena.myshopify.com/cart/62134117859699:1?channel=buy_button',
        [ShopifyStore.ROW]:
          'https://ultrahuman-us.myshopify.com/cart/42669741015100:1?channel=buy_button',
        [ShopifyStore.US]:
          'https://stelcore-x-ultrahuman.myshopify.com/cart/41731305373792:1?channel=buy_button',
        [ShopifyStore.EU]:
          'https://ultrahuman-eu-uk.myshopify.com/cart/55416353620342:1?channel=buy_button',
        [ShopifyStore.GB]:
          'https://ultrahuman-eu-uk.myshopify.com/cart/55416353620342:1?channel=buy_button',
      },
      misc: {
        [MiscRingCheckoutTypes.BETTER_HELP_CHECKOUT]: '',
      },
    },
  },
  [RareColors.DESERT_ROSE]: {
    [RingSizes.FIVE]: {
      SKU: 'RARE_DR_5',
      variantId: {
        [ShopifyStore.IN]: 'gid://shopify/ProductVariant/42764589596742',
        [ShopifyStore.AE]: 'gid://shopify/ProductVariant/62134112223603',
        [ShopifyStore.ROW]: 'gid://shopify/ProductVariant/42669717848124',
        [ShopifyStore.US]: 'gid://shopify/ProductVariant/41731305046112',
        [ShopifyStore.EU]: 'gid://shopify/ProductVariant/55416342446454',
        [ShopifyStore.GB]: 'gid://shopify/ProductVariant/55416342446454',
      },
      checkoutUrl: {
        [ShopifyStore.IN]:
          'https://ultrahumanstore.myshopify.com/cart/42764589596742:1?channel=buy_button',
        [ShopifyStore.AE]:
          'https://ultrahuman-mena.myshopify.com/cart/62134112223603:1?channel=buy_button',
        [ShopifyStore.ROW]:
          'https://ultrahuman-us.myshopify.com/cart/42669717848124:1?channel=buy_button',
        [ShopifyStore.US]:
          'https://stelcore-x-ultrahuman.myshopify.com/cart/41731305046112:1?channel=buy_button',
        [ShopifyStore.EU]:
          'https://ultrahuman-eu-uk.myshopify.com/cart/55416342446454:1?channel=buy_button',
        [ShopifyStore.GB]:
          'https://ultrahuman-eu-uk.myshopify.com/cart/55416342446454:1?channel=buy_button',
      },
      misc: {
        [MiscRingCheckoutTypes.BETTER_HELP_CHECKOUT]: '',
      },
    },
    [RingSizes.SIX]: {
      SKU: 'RARE_DR_6',
      variantId: {
        [ShopifyStore.IN]: 'gid://shopify/ProductVariant/42764589629510',
        [ShopifyStore.AE]: 'gid://shopify/ProductVariant/62134112256371',
        [ShopifyStore.ROW]: 'gid://shopify/ProductVariant/42669717880892',
        [ShopifyStore.US]: 'gid://shopify/ProductVariant/41731294298208',
        [ShopifyStore.EU]: 'gid://shopify/ProductVariant/55416342479222',
        [ShopifyStore.GB]: 'gid://shopify/ProductVariant/55416342479222',
      },
      checkoutUrl: {
        [ShopifyStore.IN]:
          'https://ultrahumanstore.myshopify.com/cart/42764589629510:1?channel=buy_button',
        [ShopifyStore.AE]:
          'https://ultrahuman-mena.myshopify.com/cart/62134112256371:1?channel=buy_button',
        [ShopifyStore.ROW]:
          'https://ultrahuman-us.myshopify.com/cart/42669717880892:1?channel=buy_button',
        [ShopifyStore.US]:
          'https://stelcore-x-ultrahuman.myshopify.com/cart/41731294298208:1?channel=buy_button',
        [ShopifyStore.EU]:
          'https://ultrahuman-eu-uk.myshopify.com/cart/55416342479222:1?channel=buy_button',
        [ShopifyStore.GB]:
          'https://ultrahuman-eu-uk.myshopify.com/cart/55416342479222:1?channel=buy_button',
      },
      misc: {
        [MiscRingCheckoutTypes.BETTER_HELP_CHECKOUT]: '',
      },
    },
    [RingSizes.SEVEN]: {
      SKU: 'RARE_DR_7',
      variantId: {
        [ShopifyStore.IN]: 'gid://shopify/ProductVariant/42764589662278',
        [ShopifyStore.AE]: 'gid://shopify/ProductVariant/62134112289139',
        [ShopifyStore.ROW]: 'gid://shopify/ProductVariant/42669717913660',
        [ShopifyStore.US]: 'gid://shopify/ProductVariant/41731294330976',
        [ShopifyStore.EU]: 'gid://shopify/ProductVariant/55416342511990',
        [ShopifyStore.GB]: 'gid://shopify/ProductVariant/55416342511990',
      },
      checkoutUrl: {
        [ShopifyStore.IN]:
          'https://ultrahumanstore.myshopify.com/cart/42764589662278:1?channel=buy_button',
        [ShopifyStore.AE]:
          'https://ultrahuman-mena.myshopify.com/cart/62134112289139:1?channel=buy_button',
        [ShopifyStore.ROW]:
          'https://ultrahuman-us.myshopify.com/cart/42669717913660:1?channel=buy_button',
        [ShopifyStore.US]:
          'https://stelcore-x-ultrahuman.myshopify.com/cart/41731294330976:1?channel=buy_button',
        [ShopifyStore.EU]:
          'https://ultrahuman-eu-uk.myshopify.com/cart/55416342511990:1?channel=buy_button',
        [ShopifyStore.GB]:
          'https://ultrahuman-eu-uk.myshopify.com/cart/55416342511990:1?channel=buy_button',
      },
      misc: {
        [MiscRingCheckoutTypes.BETTER_HELP_CHECKOUT]: '',
      },
    },
    [RingSizes.EIGHT]: {
      SKU: 'RARE_DR_8',
      variantId: {
        [ShopifyStore.IN]: 'gid://shopify/ProductVariant/42764589695046',
        [ShopifyStore.AE]: 'gid://shopify/ProductVariant/62134112321907',
        [ShopifyStore.ROW]: 'gid://shopify/ProductVariant/42669717946428',
        [ShopifyStore.US]: 'gid://shopify/ProductVariant/41731294363744',
        [ShopifyStore.EU]: 'gid://shopify/ProductVariant/55416342544758',
        [ShopifyStore.GB]: 'gid://shopify/ProductVariant/55416342544758',
      },
      checkoutUrl: {
        [ShopifyStore.IN]:
          'https://ultrahumanstore.myshopify.com/cart/42764589695046:1?channel=buy_button',
        [ShopifyStore.AE]:
          'https://ultrahuman-mena.myshopify.com/cart/62134112321907:1?channel=buy_button',
        [ShopifyStore.ROW]:
          'https://ultrahuman-us.myshopify.com/cart/42669717946428:1?channel=buy_button',
        [ShopifyStore.US]:
          'https://stelcore-x-ultrahuman.myshopify.com/cart/41731294363744:1?channel=buy_button',
        [ShopifyStore.EU]:
          'https://ultrahuman-eu-uk.myshopify.com/cart/55416342544758:1?channel=buy_button',
        [ShopifyStore.GB]:
          'https://ultrahuman-eu-uk.myshopify.com/cart/55416342544758:1?channel=buy_button',
      },
      misc: {
        [MiscRingCheckoutTypes.BETTER_HELP_CHECKOUT]: '',
      },
    },
    [RingSizes.NINE]: {
      SKU: 'RARE_DR_9',
      variantId: {
        [ShopifyStore.IN]: 'gid://shopify/ProductVariant/42764589727814',
        [ShopifyStore.AE]: 'gid://shopify/ProductVariant/62134112354675',
        [ShopifyStore.ROW]: 'gid://shopify/ProductVariant/42669717979196',
        [ShopifyStore.US]: 'gid://shopify/ProductVariant/41731294396512',
        [ShopifyStore.EU]: 'gid://shopify/ProductVariant/55416342577526',
        [ShopifyStore.GB]: 'gid://shopify/ProductVariant/55416342577526',
      },
      checkoutUrl: {
        [ShopifyStore.IN]:
          'https://ultrahumanstore.myshopify.com/cart/42764589727814:1?channel=buy_button',
        [ShopifyStore.AE]:
          'https://ultrahuman-mena.myshopify.com/cart/62134112354675:1?channel=buy_button',
        [ShopifyStore.ROW]:
          'https://ultrahuman-us.myshopify.com/cart/42669717979196:1?channel=buy_button',
        [ShopifyStore.US]:
          'https://stelcore-x-ultrahuman.myshopify.com/cart/41731294396512:1?channel=buy_button',
        [ShopifyStore.EU]:
          'https://ultrahuman-eu-uk.myshopify.com/cart/55416342577526:1?channel=buy_button',
        [ShopifyStore.GB]:
          'https://ultrahuman-eu-uk.myshopify.com/cart/55416342577526:1?channel=buy_button',
      },
      misc: {
        [MiscRingCheckoutTypes.BETTER_HELP_CHECKOUT]: '',
      },
    },
    [RingSizes.TEN]: {
      SKU: 'RARE_DR_10',
      variantId: {
        [ShopifyStore.IN]: 'gid://shopify/ProductVariant/42764589760582',
        [ShopifyStore.AE]: 'gid://shopify/ProductVariant/62134112387443',
        [ShopifyStore.ROW]: 'gid://shopify/ProductVariant/42669718011964',
        [ShopifyStore.US]: 'gid://shopify/ProductVariant/41731294429280',
        [ShopifyStore.EU]: 'gid://shopify/ProductVariant/55416342610294',
        [ShopifyStore.GB]: 'gid://shopify/ProductVariant/55416342610294',
      },
      checkoutUrl: {
        [ShopifyStore.IN]:
          'https://ultrahumanstore.myshopify.com/cart/42764589760582:1?channel=buy_button',
        [ShopifyStore.AE]:
          'https://ultrahuman-mena.myshopify.com/cart/62134112387443:1?channel=buy_button',
        [ShopifyStore.ROW]:
          'https://ultrahuman-us.myshopify.com/cart/42669718011964:1?channel=buy_button',
        [ShopifyStore.US]:
          'https://stelcore-x-ultrahuman.myshopify.com/cart/41731294429280:1?channel=buy_button',
        [ShopifyStore.EU]:
          'https://ultrahuman-eu-uk.myshopify.com/cart/55416342610294:1?channel=buy_button',
        [ShopifyStore.GB]:
          'https://ultrahuman-eu-uk.myshopify.com/cart/55416342610294:1?channel=buy_button',
      },
      misc: {
        [MiscRingCheckoutTypes.BETTER_HELP_CHECKOUT]: '',
      },
    },
    [RingSizes.ELEVEN]: {
      SKU: 'RARE_DR_11',
      variantId: {
        [ShopifyStore.IN]: 'gid://shopify/ProductVariant/42764589793350',
        [ShopifyStore.AE]: 'gid://shopify/ProductVariant/62134112420211',
        [ShopifyStore.ROW]: 'gid://shopify/ProductVariant/42669718044732',
        [ShopifyStore.US]: 'gid://shopify/ProductVariant/41731294462048',
        [ShopifyStore.EU]: 'gid://shopify/ProductVariant/55416342643062',
        [ShopifyStore.GB]: 'gid://shopify/ProductVariant/55416342643062',
      },
      checkoutUrl: {
        [ShopifyStore.IN]:
          'https://ultrahumanstore.myshopify.com/cart/42764589793350:1?channel=buy_button',
        [ShopifyStore.AE]:
          'https://ultrahuman-mena.myshopify.com/cart/62134112420211:1?channel=buy_button',
        [ShopifyStore.ROW]:
          'https://ultrahuman-us.myshopify.com/cart/42669718044732:1?channel=buy_button',
        [ShopifyStore.US]:
          'https://stelcore-x-ultrahuman.myshopify.com/cart/41731294462048:1?channel=buy_button',
        [ShopifyStore.EU]:
          'https://ultrahuman-eu-uk.myshopify.com/cart/55416342643062:1?channel=buy_button',
        [ShopifyStore.GB]:
          'https://ultrahuman-eu-uk.myshopify.com/cart/55416342643062:1?channel=buy_button',
      },
      misc: {
        [MiscRingCheckoutTypes.BETTER_HELP_CHECKOUT]: '',
      },
    },
    [RingSizes.TWELVE]: {
      SKU: 'RARE_DR_12',
      variantId: {
        [ShopifyStore.IN]: 'gid://shopify/ProductVariant/42764589826118',
        [ShopifyStore.AE]: 'gid://shopify/ProductVariant/62134112452979',
        [ShopifyStore.ROW]: 'gid://shopify/ProductVariant/42669718077500',
        [ShopifyStore.US]: 'gid://shopify/ProductVariant/41731294494816',
        [ShopifyStore.EU]: 'gid://shopify/ProductVariant/55416342675830',
        [ShopifyStore.GB]: 'gid://shopify/ProductVariant/55416342675830',
      },
      checkoutUrl: {
        [ShopifyStore.IN]:
          'https://ultrahumanstore.myshopify.com/cart/42764589826118:1?channel=buy_button',
        [ShopifyStore.AE]:
          'https://ultrahuman-mena.myshopify.com/cart/62134112452979:1?channel=buy_button',
        [ShopifyStore.ROW]:
          'https://ultrahuman-us.myshopify.com/cart/42669718077500:1?channel=buy_button',
        [ShopifyStore.US]:
          'https://stelcore-x-ultrahuman.myshopify.com/cart/41731294494816:1?channel=buy_button',
        [ShopifyStore.EU]:
          'https://ultrahuman-eu-uk.myshopify.com/cart/55416342675830:1?channel=buy_button',
        [ShopifyStore.GB]:
          'https://ultrahuman-eu-uk.myshopify.com/cart/55416342675830:1?channel=buy_button',
      },
      misc: {
        [MiscRingCheckoutTypes.BETTER_HELP_CHECKOUT]: '',
      },
    },
    [RingSizes.THIRTEEN]: {
      SKU: 'RARE_DR_13',
      variantId: {
        [ShopifyStore.IN]: 'gid://shopify/ProductVariant/42764589858886',
        [ShopifyStore.AE]: 'gid://shopify/ProductVariant/62134112485747',
        [ShopifyStore.ROW]: 'gid://shopify/ProductVariant/42669718110268',
        [ShopifyStore.US]: 'gid://shopify/ProductVariant/41731294527584',
        [ShopifyStore.EU]: 'gid://shopify/ProductVariant/55416342708598',
        [ShopifyStore.GB]: 'gid://shopify/ProductVariant/55416342708598',
      },
      checkoutUrl: {
        [ShopifyStore.IN]:
          'https://ultrahumanstore.myshopify.com/cart/42764589858886:1?channel=buy_button',
        [ShopifyStore.AE]:
          'https://ultrahuman-mena.myshopify.com/cart/62134112485747:1?channel=buy_button',
        [ShopifyStore.ROW]:
          'https://ultrahuman-us.myshopify.com/cart/42669718110268:1?channel=buy_button',
        [ShopifyStore.US]:
          'https://stelcore-x-ultrahuman.myshopify.com/cart/41731294527584:1?channel=buy_button',
        [ShopifyStore.EU]:
          'https://ultrahuman-eu-uk.myshopify.com/cart/55416342708598:1?channel=buy_button',
        [ShopifyStore.GB]:
          'https://ultrahuman-eu-uk.myshopify.com/cart/55416342708598:1?channel=buy_button',
      },
      misc: {
        [MiscRingCheckoutTypes.BETTER_HELP_CHECKOUT]: '',
      },
    },
    [RingSizes.FOURTEEN]: {
      SKU: 'RARE_DR_14',
      variantId: {
        [ShopifyStore.IN]: 'gid://shopify/ProductVariant/42764589891654',
        [ShopifyStore.AE]: 'gid://shopify/ProductVariant/62134112518515',
        [ShopifyStore.ROW]: 'gid://shopify/ProductVariant/42669718143036',
        [ShopifyStore.US]: 'gid://shopify/ProductVariant/41731294560352',
        [ShopifyStore.EU]: 'gid://shopify/ProductVariant/55416342741366',
        [ShopifyStore.GB]: 'gid://shopify/ProductVariant/55416342741366',
      },
      checkoutUrl: {
        [ShopifyStore.IN]:
          'https://ultrahumanstore.myshopify.com/cart/42764589891654:1?channel=buy_button',
        [ShopifyStore.AE]:
          'https://ultrahuman-mena.myshopify.com/cart/62134112518515:1?channel=buy_button',
        [ShopifyStore.ROW]:
          'https://ultrahuman-us.myshopify.com/cart/42669718143036:1?channel=buy_button',
        [ShopifyStore.US]:
          'https://stelcore-x-ultrahuman.myshopify.com/cart/41731294560352:1?channel=buy_button',
        [ShopifyStore.EU]:
          'https://ultrahuman-eu-uk.myshopify.com/cart/55416342741366:1?channel=buy_button',
        [ShopifyStore.GB]:
          'https://ultrahuman-eu-uk.myshopify.com/cart/55416342741366:1?channel=buy_button',
      },
      misc: {
        [MiscRingCheckoutTypes.BETTER_HELP_CHECKOUT]: '',
      },
    },
    [RingSizes.OPEN]: {
      SKU: 'LR00',
      variantId: {
        [ShopifyStore.IN]: 'gid://shopify/ProductVariant/42764589924422',
        [ShopifyStore.AE]: 'gid://shopify/ProductVariant/62134112551283',
        [ShopifyStore.ROW]: 'gid://shopify/ProductVariant/42669718175804',
        [ShopifyStore.US]: 'gid://shopify/ProductVariant/41731294593120',
        [ShopifyStore.EU]: 'gid://shopify/ProductVariant/55416342774134',
        [ShopifyStore.GB]: 'gid://shopify/ProductVariant/55416342774134',
      },
      checkoutUrl: {
        [ShopifyStore.IN]:
          'https://ultrahumanstore.myshopify.com/cart/42764589924422:1?channel=buy_button',
        [ShopifyStore.AE]:
          'https://ultrahuman-mena.myshopify.com/cart/62134112551283:1?channel=buy_button',
        [ShopifyStore.ROW]:
          'https://ultrahuman-us.myshopify.com/cart/42669718175804:1?channel=buy_button',
        [ShopifyStore.US]:
          'https://stelcore-x-ultrahuman.myshopify.com/cart/41731294593120:1?channel=buy_button',
        [ShopifyStore.EU]:
          'https://ultrahuman-eu-uk.myshopify.com/cart/55416342774134:1?channel=buy_button',
        [ShopifyStore.GB]:
          'https://ultrahuman-eu-uk.myshopify.com/cart/55416342774134:1?channel=buy_button',
      },
      misc: {
        [MiscRingCheckoutTypes.BETTER_HELP_CHECKOUT]: '',
      },
    },
  },
  [RareColors.DUNE]: {
    // Same structure as DESERT_SNOW but with DU prefix and different placeholder IDs
    [RingSizes.FIVE]: {
      SKU: 'RARE_DU_5',
      variantId: {
        [ShopifyStore.IN]: 'gid://shopify/ProductVariant/42764592414790',
        [ShopifyStore.AE]: 'gid://shopify/ProductVariant/62134115664243',
        [ShopifyStore.ROW]: 'gid://shopify/ProductVariant/42669738164284',
        [ShopifyStore.US]: 'gid://shopify/ProductVariant/41731304030304',
        [ShopifyStore.EU]: 'gid://shopify/ProductVariant/55416348705142',
        [ShopifyStore.GB]: 'gid://shopify/ProductVariant/55416348705142',
      },
      checkoutUrl: {
        [ShopifyStore.IN]:
          'https://ultrahumanstore.myshopify.com/cart/42764592414790:1?channel=buy_button',
        [ShopifyStore.AE]:
          'https://ultrahuman-mena.myshopify.com/cart/62134115664243:1?channel=buy_button',
        [ShopifyStore.ROW]:
          'https://ultrahuman-us.myshopify.com/cart/42669738164284:1?channel=buy_button',
        [ShopifyStore.US]:
          'https://stelcore-x-ultrahuman.myshopify.com/cart/41731304030304:1?channel=buy_button',
        [ShopifyStore.EU]:
          'https://ultrahuman-eu-uk.myshopify.com/cart/55416348705142:1?channel=buy_button',
        [ShopifyStore.GB]:
          'https://ultrahuman-eu-uk.myshopify.com/cart/55416348705142:1?channel=buy_button',
      },
      misc: {
        [MiscRingCheckoutTypes.BETTER_HELP_CHECKOUT]: '',
      },
    },
    [RingSizes.SIX]: {
      SKU: 'RARE_DU_6',
      variantId: {
        [ShopifyStore.IN]: 'gid://shopify/ProductVariant/42764592447558',
        [ShopifyStore.AE]: 'gid://shopify/ProductVariant/62134115697011',
        [ShopifyStore.ROW]: 'gid://shopify/ProductVariant/42669738197052',
        [ShopifyStore.US]: 'gid://shopify/ProductVariant/41731304063072',
        [ShopifyStore.EU]: 'gid://shopify/ProductVariant/55416348737910',
        [ShopifyStore.GB]: 'gid://shopify/ProductVariant/55416348737910',
      },
      checkoutUrl: {
        [ShopifyStore.IN]:
          'https://ultrahumanstore.myshopify.com/cart/42764592447558:1?channel=buy_button',
        [ShopifyStore.AE]:
          'https://ultrahuman-mena.myshopify.com/cart/62134115697011:1?channel=buy_button',
        [ShopifyStore.ROW]:
          'https://ultrahuman-us.myshopify.com/cart/42669738197052:1?channel=buy_button',
        [ShopifyStore.US]:
          'https://stelcore-x-ultrahuman.myshopify.com/cart/41731304063072:1?channel=buy_button',
        [ShopifyStore.EU]:
          'https://ultrahuman-eu-uk.myshopify.com/cart/55416348737910:1?channel=buy_button',
        [ShopifyStore.GB]:
          'https://ultrahuman-eu-uk.myshopify.com/cart/55416348737910:1?channel=buy_button',
      },
      misc: {
        [MiscRingCheckoutTypes.BETTER_HELP_CHECKOUT]: '',
      },
    },
    [RingSizes.SEVEN]: {
      SKU: 'RARE_DU_7',
      variantId: {
        [ShopifyStore.IN]: 'gid://shopify/ProductVariant/42764592480326',
        [ShopifyStore.AE]: 'gid://shopify/ProductVariant/62134115729779',
        [ShopifyStore.ROW]: 'gid://shopify/ProductVariant/42669738229820',
        [ShopifyStore.US]: 'gid://shopify/ProductVariant/41731304095840',
        [ShopifyStore.EU]: 'gid://shopify/ProductVariant/55416348770678',
        [ShopifyStore.GB]: 'gid://shopify/ProductVariant/55416348770678',
      },
      checkoutUrl: {
        [ShopifyStore.IN]:
          'https://ultrahumanstore.myshopify.com/cart/42764592480326:1?channel=buy_button',
        [ShopifyStore.AE]:
          'https://ultrahuman-mena.myshopify.com/cart/62134115729779:1?channel=buy_button',
        [ShopifyStore.ROW]:
          'https://ultrahuman-us.myshopify.com/cart/42669738229820:1?channel=buy_button',
        [ShopifyStore.US]:
          'https://stelcore-x-ultrahuman.myshopify.com/cart/41731304095840:1?channel=buy_button',
        [ShopifyStore.EU]:
          'https://ultrahuman-eu-uk.myshopify.com/cart/55416348770678:1?channel=buy_button',
        [ShopifyStore.GB]:
          'https://ultrahuman-eu-uk.myshopify.com/cart/55416348770678:1?channel=buy_button',
      },
      misc: {
        [MiscRingCheckoutTypes.BETTER_HELP_CHECKOUT]: '',
      },
    },
    [RingSizes.EIGHT]: {
      SKU: 'RARE_DU_8',
      variantId: {
        [ShopifyStore.IN]: 'gid://shopify/ProductVariant/42764592513094',
        [ShopifyStore.AE]: 'gid://shopify/ProductVariant/62134115762547',
        [ShopifyStore.ROW]: 'gid://shopify/ProductVariant/42669738262588',
        [ShopifyStore.US]: 'gid://shopify/ProductVariant/41731304128608',
        [ShopifyStore.EU]: 'gid://shopify/ProductVariant/56326679527798',
        [ShopifyStore.GB]: 'gid://shopify/ProductVariant/56326679527798',
      },
      checkoutUrl: {
        [ShopifyStore.IN]:
          'https://ultrahumanstore.myshopify.com/cart/42764592513094:1?channel=buy_button',
        [ShopifyStore.AE]:
          'https://ultrahuman-mena.myshopify.com/cart/62134115762547:1?channel=buy_button',
        [ShopifyStore.ROW]:
          'https://ultrahuman-us.myshopify.com/cart/42669738262588:1?channel=buy_button',
        [ShopifyStore.US]:
          'https://stelcore-x-ultrahuman.myshopify.com/cart/41731304128608:1?channel=buy_button',
        [ShopifyStore.EU]:
          'https://ultrahuman-eu-uk.myshopify.com/cart/56326679527798:1?channel=buy_button',
        [ShopifyStore.GB]:
          'https://ultrahuman-eu-uk.myshopify.com/cart/56326679527798:1?channel=buy_button',
      },
      misc: {
        [MiscRingCheckoutTypes.BETTER_HELP_CHECKOUT]: '',
      },
    },
    [RingSizes.NINE]: {
      SKU: 'RARE_DU_9',
      variantId: {
        [ShopifyStore.IN]: 'gid://shopify/ProductVariant/42764592545862',
        [ShopifyStore.AE]: 'gid://shopify/ProductVariant/62134115795315',
        [ShopifyStore.ROW]: 'gid://shopify/ProductVariant/42669738295356',
        [ShopifyStore.US]: 'gid://shopify/ProductVariant/41731304161376',
        [ShopifyStore.EU]: 'gid://shopify/ProductVariant/55416348836214',
        [ShopifyStore.GB]: 'gid://shopify/ProductVariant/55416348836214',
      },
      checkoutUrl: {
        [ShopifyStore.IN]:
          'https://ultrahumanstore.myshopify.com/cart/42764592545862:1?channel=buy_button',
        [ShopifyStore.AE]:
          'https://ultrahuman-mena.myshopify.com/cart/62134115795315:1?channel=buy_button',
        [ShopifyStore.ROW]:
          'https://ultrahuman-us.myshopify.com/cart/42669738295356:1?channel=buy_button',
        [ShopifyStore.US]:
          'https://stelcore-x-ultrahuman.myshopify.com/cart/41731304161376:1?channel=buy_button',
        [ShopifyStore.EU]:
          'https://ultrahuman-eu-uk.myshopify.com/cart/55416348836214:1?channel=buy_button',
        [ShopifyStore.GB]:
          'https://ultrahuman-eu-uk.myshopify.com/cart/55416348836214:1?channel=buy_button',
      },
      misc: {
        [MiscRingCheckoutTypes.BETTER_HELP_CHECKOUT]: '',
      },
    },
    [RingSizes.TEN]: {
      SKU: 'RARE_DU_10',
      variantId: {
        [ShopifyStore.IN]: 'gid://shopify/ProductVariant/42764592578630',
        [ShopifyStore.AE]: 'gid://shopify/ProductVariant/62134115828083',
        [ShopifyStore.ROW]: 'gid://shopify/ProductVariant/42669738328124',
        [ShopifyStore.US]: 'gid://shopify/ProductVariant/41731304194144',
        [ShopifyStore.EU]: 'gid://shopify/ProductVariant/55416348868982',
        [ShopifyStore.GB]: 'gid://shopify/ProductVariant/55416348868982',
      },
      checkoutUrl: {
        [ShopifyStore.IN]:
          'https://ultrahumanstore.myshopify.com/cart/42764592578630:1?channel=buy_button',
        [ShopifyStore.AE]:
          'https://ultrahuman-mena.myshopify.com/cart/62134115828083:1?channel=buy_button',
        [ShopifyStore.ROW]:
          'https://ultrahuman-us.myshopify.com/cart/42669738328124:1?channel=buy_button',
        [ShopifyStore.US]:
          'https://stelcore-x-ultrahuman.myshopify.com/cart/41731304194144:1?channel=buy_button',
        [ShopifyStore.EU]:
          'https://ultrahuman-eu-uk.myshopify.com/cart/55416348868982:1?channel=buy_button',
        [ShopifyStore.GB]:
          'https://ultrahuman-eu-uk.myshopify.com/cart/55416348868982:1?channel=buy_button',
      },
      misc: {
        [MiscRingCheckoutTypes.BETTER_HELP_CHECKOUT]: '',
      },
    },
    [RingSizes.ELEVEN]: {
      SKU: 'RARE_DU_11',
      variantId: {
        [ShopifyStore.IN]: 'gid://shopify/ProductVariant/42764592611398',
        [ShopifyStore.AE]: 'gid://shopify/ProductVariant/62134115860851',
        [ShopifyStore.ROW]: 'gid://shopify/ProductVariant/42669738360892',
        [ShopifyStore.US]: 'gid://shopify/ProductVariant/41731304226912',
        [ShopifyStore.EU]: 'gid://shopify/ProductVariant/55416348901750',
        [ShopifyStore.GB]: 'gid://shopify/ProductVariant/55416348901750',
      },
      checkoutUrl: {
        [ShopifyStore.IN]:
          'https://ultrahumanstore.myshopify.com/cart/42764592611398:1?channel=buy_button',
        [ShopifyStore.AE]:
          'https://ultrahuman-mena.myshopify.com/cart/62134115860851:1?channel=buy_button',
        [ShopifyStore.ROW]:
          'https://ultrahuman-us.myshopify.com/cart/42669738360892:1?channel=buy_button',
        [ShopifyStore.US]:
          'https://stelcore-x-ultrahuman.myshopify.com/cart/41731304226912:1?channel=buy_button',
        [ShopifyStore.EU]:
          'hhttps://ultrahuman-eu-uk.myshopify.com/cart/55416348901750:1?channel=buy_button',
        [ShopifyStore.GB]:
          'https://ultrahuman-eu-uk.myshopify.com/cart/55416348901750:1?channel=buy_button',
      },
      misc: {
        [MiscRingCheckoutTypes.BETTER_HELP_CHECKOUT]: '',
      },
    },
    [RingSizes.TWELVE]: {
      SKU: 'RARE_DU_12',
      variantId: {
        [ShopifyStore.IN]: 'gid://shopify/ProductVariant/42764592644166',
        [ShopifyStore.AE]: 'gid://shopify/ProductVariant/62134115893619',
        [ShopifyStore.ROW]: 'gid://shopify/ProductVariant/42669738393660',
        [ShopifyStore.US]: 'gid://shopify/ProductVariant/41731304259680',
        [ShopifyStore.EU]: 'gid://shopify/ProductVariant/55416348934518',
        [ShopifyStore.GB]: 'gid://shopify/ProductVariant/55416348934518',
      },
      checkoutUrl: {
        [ShopifyStore.IN]:
          'https://ultrahumanstore.myshopify.com/cart/42764592644166:1?channel=buy_button',
        [ShopifyStore.AE]:
          'https://ultrahuman-mena.myshopify.com/cart/62134115893619:1?channel=buy_button',
        [ShopifyStore.ROW]:
          'https://ultrahuman-us.myshopify.com/cart/42669738393660:1?channel=buy_button',
        [ShopifyStore.US]:
          'https://stelcore-x-ultrahuman.myshopify.com/cart/41731304259680:1?channel=buy_button',
        [ShopifyStore.EU]:
          'https://ultrahuman-eu-uk.myshopify.com/cart/55416348934518:1?channel=buy_button',
        [ShopifyStore.GB]:
          'https://ultrahuman-eu-uk.myshopify.com/cart/55416348934518:1?channel=buy_button',
      },
      misc: {
        [MiscRingCheckoutTypes.BETTER_HELP_CHECKOUT]: '',
      },
    },
    [RingSizes.THIRTEEN]: {
      SKU: 'RARE_DU_13',
      variantId: {
        [ShopifyStore.IN]: 'gid://shopify/ProductVariant/42764592676934',
        [ShopifyStore.AE]: 'gid://shopify/ProductVariant/62134115926387',
        [ShopifyStore.ROW]: 'gid://shopify/ProductVariant/42669738426428',
        [ShopifyStore.US]: 'gid://shopify/ProductVariant/41731304292448',
        [ShopifyStore.EU]: 'gid://shopify/ProductVariant/55416348967286',
        [ShopifyStore.GB]: 'gid://shopify/ProductVariant/55416348967286',
      },
      checkoutUrl: {
        [ShopifyStore.IN]:
          'https://ultrahumanstore.myshopify.com/cart/42764592676934:1?channel=buy_button',
        [ShopifyStore.AE]:
          'https://ultrahuman-mena.myshopify.com/cart/62134115926387:1?channel=buy_button',
        [ShopifyStore.ROW]:
          'https://ultrahuman-us.myshopify.com/cart/42669738426428:1?channel=buy_button',
        [ShopifyStore.US]:
          'https://stelcore-x-ultrahuman.myshopify.com/cart/41731304292448:1?channel=buy_button',
        [ShopifyStore.EU]:
          'https://ultrahuman-eu-uk.myshopify.com/cart/55416348967286:1?channel=buy_button',
        [ShopifyStore.GB]:
          'https://ultrahuman-eu-uk.myshopify.com/cart/55416348967286:1?channel=buy_button',
      },
      misc: {
        [MiscRingCheckoutTypes.BETTER_HELP_CHECKOUT]: '',
      },
    },
    [RingSizes.FOURTEEN]: {
      SKU: 'RARE_DU_14',
      variantId: {
        [ShopifyStore.IN]: 'gid://shopify/ProductVariant/42764592709702',
        [ShopifyStore.AE]: 'gid://shopify/ProductVariant/62134115959155',
        [ShopifyStore.ROW]: 'gid://shopify/ProductVariant/42669738459196',
        [ShopifyStore.US]: 'gid://shopify/ProductVariant/41731304325216',
        [ShopifyStore.EU]: 'gid://shopify/ProductVariant/55416349000054',
        [ShopifyStore.GB]: 'gid://shopify/ProductVariant/55416349000054',
      },
      checkoutUrl: {
        [ShopifyStore.IN]:
          'https://ultrahumanstore.myshopify.com/cart/42764592709702:1?channel=buy_button',
        [ShopifyStore.AE]:
          'https://ultrahuman-mena.myshopify.com/cart/62134115959155:1?channel=buy_button',
        [ShopifyStore.ROW]:
          'https://ultrahuman-us.myshopify.com/cart/42669738459196:1?channel=buy_button',
        [ShopifyStore.US]:
          'https://stelcore-x-ultrahuman.myshopify.com/cart/41731304325216:1?channel=buy_button',
        [ShopifyStore.EU]:
          'https://ultrahuman-eu-uk.myshopify.com/cart/55416349000054:1?channel=buy_button',
        [ShopifyStore.GB]:
          'https://ultrahuman-eu-uk.myshopify.com/cart/55416349000054:1?channel=buy_button',
      },
      misc: {
        [MiscRingCheckoutTypes.BETTER_HELP_CHECKOUT]: '',
      },
    },
    [RingSizes.OPEN]: {
      SKU: 'LG00',
      variantId: {
        [ShopifyStore.IN]: 'gid://shopify/ProductVariant/42764592742470',
        [ShopifyStore.AE]: 'gid://shopify/ProductVariant/62134115991923',
        [ShopifyStore.ROW]: 'gid://shopify/ProductVariant/42669738491964',
        [ShopifyStore.US]: 'gid://shopify/ProductVariant/41731304357984',
        [ShopifyStore.EU]: 'gid://shopify/ProductVariant/55416349032822',
        [ShopifyStore.GB]: 'gid://shopify/ProductVariant/55416349032822',
      },
      checkoutUrl: {
        [ShopifyStore.IN]:
          'https://ultrahumanstore.myshopify.com/cart/42764592742470:1?channel=buy_button',
        [ShopifyStore.AE]:
          'https://ultrahuman-mena.myshopify.com/cart/62134115991923:1?channel=buy_button',
        [ShopifyStore.ROW]:
          'https://ultrahuman-us.myshopify.com/cart/42669738491964:1?channel=buy_button',
        [ShopifyStore.US]:
          'https://stelcore-x-ultrahuman.myshopify.com/cart/41731304357984:1?channel=buy_button',
        [ShopifyStore.EU]:
          'https://ultrahuman-eu-uk.myshopify.com/cart/55416349032822:1?channel=buy_button',
        [ShopifyStore.GB]:
          'https://ultrahuman-eu-uk.myshopify.com/cart/55416349032822:1?channel=buy_button',
      },
      misc: {
        [MiscRingCheckoutTypes.BETTER_HELP_CHECKOUT]: '',
      },
    },
  },
};

// Apply store aliasing to expand GB/AU/CA configurations
// This automatically fills in aliased stores (GB->EU, AU->EU, CA->US)
export const productMap_rare_PROD_expanded =
  deepExpandStoreAliases(productMap_rare_PROD);
